import { axiosInstance } from '../clients/axiosClient';
import {
  ListFoodsResponse,
  CreateFoodRequest,
  UpdateFoodRequest,
  CreateFoodResponse,
  UpdateFoodResponse
} from '../types/apiGeneratedTypes';
import { FOOD_API_PREFIX, API_V1_PREFIX } from '../utils/constants';

export const getFoodList = async (
  search?: string,
  sort_by?: string,
  sort_direction?: string
): Promise<ListFoodsResponse> => {
  try {
    const params: any = {
      name: search || '',
    };

    if (sort_by) {params.sort_by = sort_by;}
    if (sort_direction) {params.sort_direction = sort_direction;}

    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${FOOD_API_PREFIX}list`,
      { params }
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const createFood = async (
  newFoodRequestObject: CreateFoodRequest
): Promise<CreateFoodResponse> => {
  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${FOOD_API_PREFIX}`,
      newFoodRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const updateFood = async (
  foodRequestObject: UpdateFoodRequest
): Promise<UpdateFoodResponse> => {
  try {
    const { data } = await axiosInstance.patch(
      `${API_V1_PREFIX}${FOOD_API_PREFIX}`,
      foodRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const deleteFood = async (id: number | string): Promise<any> => {
  try {
    await axiosInstance.delete(`${API_V1_PREFIX}${FOOD_API_PREFIX}`, {
      data: {
        id: id
      }
    });
    return true;
  } catch (error: any) {
    return error.response.data;
  }
};
